import { ArrowForwardIos } from "@mui/icons-material";
import { styled, Typography } from "@mui/material";
import { ProductDto } from "../../services/generated.schemas";
import ProductsGrid from "../general/ProductsGrid";

const CollectionImage = styled("img")({
  width: "100%",
  height: "clamp(100px, 45vh, 600px)", // responsive height
  objectFit: "cover",
});

const ContentWrapper = styled("div")({
  marginTop: "clamp(1rem, 3vh, 3rem)", // responsive spacing
});

const HeaderRow = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "clamp(8px, 2vw, 24px)",
  padding: "clamp(1rem, 3vw, 2rem)", 
  color: "#AEAEAE",
  flexWrap: "wrap", 
});

const ArrowIcon = styled(ArrowForwardIos)({
  color: "#AEAEAE",
  fontSize: "clamp(12px, 2vw, 20px)", 
});

const CollectionsText = styled(Typography)({
  fontFamily: "Gantari, sans-serif",
  fontSize: "clamp(0.8rem, 2.5vw, 1.5rem)", 
});

const CollectionName = styled(Typography)({
  fontFamily: "Gantari, sans-serif",
  fontSize: "clamp(0.8rem, 2.5vw, 1.5rem)", 
});

type SingleCollectionType = {
  collectionId: string;
  collectionName: string;
  mainPhotoUrl: string;
  products: ProductDto[];
};

const SingleCollection = ({
  collectionId,
  collectionName,
  mainPhotoUrl,
  products,
}: SingleCollectionType) => {
  return (
    <>
      <CollectionImage loading="lazy" src={mainPhotoUrl} />
      <ContentWrapper>
        <HeaderRow>
          <CollectionsText variant="h5">COLLECTIONS</CollectionsText>
          <ArrowIcon />
          <CollectionName variant="h5">{collectionName}</CollectionName>
        </HeaderRow>
        <ProductsGrid collectionId={collectionId} products={products} />
      </ContentWrapper>
    </>
  );
};

export default SingleCollection;
